export const CONFIRMATION_MODAL_NAME = 'confirmDeleteModal';
export const CONFIRMATION_MODAL_ACTION = 'CONFIRMATION_MODAL_ACTION';
